import { Modal, ModalFuncProps } from 'antd';

interface ConfirmProps extends Omit<ModalFuncProps, 'onOk' | 'onCancel'> {}

export function modalConfirm(props: ConfirmProps) {
  return new Promise<boolean>((resolve, reject) => {
    Modal.confirm({
      ...props,
      onOk() {
        resolve(true);
      },
      onCancel() {
        resolve(false);
      },
    });
  });
}
